export default __webpack_public_path__ + "static/media/Nitrox2012.cca752e6.png";